<table class="w-100 mb-4 text-center text-adp-secondary">
  <thead class="fs-7 text-white text-uppercase">
    <tr>
      <th *ngIf="data.params.isDet" scope="col" class="px-6 py-3 bg-adp-primary border border-3 border-white">
        ALCANCE TOTAL
      </th>
      <th *ngIf="data.params.isVal" scope="col" class="px-6 py-3 bg-adp-primary border border-3 border-white">
        VALORIZACIÓN TOTAL
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td *ngIf="data.params.isDet" scope="row" class="px-6 py-4 font-medium text-secondary whitespace-nowrap">
        {{alcanceTotal.toLocaleString()}}
      </td>
      <td *ngIf="data.params.isVal" class="px-6 py-4 font-medium text-secondary whitespace-nowrap">
        {{valorTotal | dolar:data.params.currency}}
      </td>
    </tr>
  </tbody>
</table>